import type { FC } from 'react';
import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import { openJivoChat, payoutCreateKeys } from '@mwl/core-lib';
import CloseRoundIcon from '@public/assets/common/icons/closeRound.svg';
import { Button } from '@/components/Button/Button';
import { ModalMessage } from '@/components/ModalMessage/ModalMessage';
import type { PopupClasses } from '@/components/Popup/Popup.types';
import { routes } from '@/constants';
import { useWithdrawal } from '../../Withdrawal.context';
import { ConfirmationPopup } from '../ConfirmationPopup/ConfirmationPopup';
import styles from './WithdrawalModals.module.scss';
const modalMessageClasses: PopupClasses = {
  wrapper: styles.messageWrapper
};
export const WithdrawalModals: FC = () => {
  const {
    t
  } = useTranslation('payment');
  const router = useRouter();
  const {
    popup,
    closePopup,
    changePayment,
    openPopup
  } = useWithdrawal();
  const content = popup?.message ? <Trans ns="payment" i18nKey={Array.isArray(popup.message) ? popup.message[0] : popup.message} components={{
    support: <Button key={0} className={cn(styles.support)} as="button" variant="text" color="white" fontWeight="normal" onClick={openJivoChat} uppercase={false} />
  }}>
      {Array.isArray(popup.message) ? popup.message[1] : null}
    </Trans> : undefined;
  const closeSuccessModal = useCallback(() => {
    closePopup();
    changePayment();
  }, [changePayment, closePopup]);
  const handleCloseConfirmation = useCallback((isSuccess?: boolean) => {
    if (isSuccess) {
      closeSuccessModal();
    } else {
      openPopup({
        type: 'warning',
        title: t(payoutCreateKeys.warning.title),
        message: t(payoutCreateKeys.warning.message),
        buttonText: t(payoutCreateKeys.warning.button)
      });
    }
  }, [closeSuccessModal, openPopup, t]);
  const handleCloseWarning = useCallback(() => {
    if (popup?.errorCode === 'PAYOUT_LIMIT') {
      router.push(routes.home, undefined, {
        shallow: true,
        scroll: false
      });
      return;
    }
    closePopup();
  }, [closePopup, popup, router]);
  return <>
      <ModalMessage status="error" show={popup?.type === 'error'} title={popup?.title} content={content} buttonText={popup?.buttonText} popupClasses={modalMessageClasses} onClose={closePopup} data-sentry-element="ModalMessage" data-sentry-source-file="WithdrawalModals.tsx" />
      <ModalMessage status="success" show={popup?.type === 'success'} title={popup?.title} content={content} buttonText={popup?.buttonText} popupClasses={modalMessageClasses} onClose={closeSuccessModal} data-sentry-element="ModalMessage" data-sentry-source-file="WithdrawalModals.tsx" />
      <ModalMessage status="default" icon={<CloseRoundIcon className={styles.closeIcon} />} show={popup?.type === 'warning'} title={popup?.title} content={content} buttonText={popup?.buttonText || ''} popupClasses={modalMessageClasses} onClose={handleCloseWarning} onClick={closePopup} data-sentry-element="ModalMessage" data-sentry-source-file="WithdrawalModals.tsx" />
      <ConfirmationPopup show={popup?.type === 'confirmation'} onClose={handleCloseConfirmation} confirmation={popup?.confirmation} data-sentry-element="ConfirmationPopup" data-sentry-source-file="WithdrawalModals.tsx" />
    </>;
};